import React from 'react';
import { useTheme } from '@mui/material';
import { coarseStripHTML, stripAlpha } from '@jbrowse/core/util';
export default function SVGTrackLabel({ trackLabels, trackName, fontSize, trackLabelOffset, x, }) {
    const theme = useTheme();
    const fill = stripAlpha(theme.palette.text.primary);
    const xoff = trackLabels === 'overlay' ? 5 : 0;
    const yoff = trackLabels === 'offset' ? 5 : 0;
    const name = coarseStripHTML(trackName);
    return trackLabels !== 'none' ? (React.createElement("g", null, trackLabels === 'left' ? (React.createElement("text", { x: trackLabelOffset - 40, y: 20, fill: fill, fontSize: fontSize, dominantBaseline: "hanging", textAnchor: "end" }, name)) : (React.createElement("text", { x: x + xoff, y: yoff, fill: fill, fontSize: fontSize, dominantBaseline: "hanging" }, name)))) : null;
}
